import * as SalesStore from 'pos/modules/main/SalesStore';
import { Result } from 'core/infrastructure';
import { Preconditions } from 'core/infrastructure-next';

import { Command } from 'pos/common';

declare global {
	interface CommandType {
		handleLoyalty: () => Promise<Result>
	}
}

Command.register('handleLoyalty', Preconditions.ensureIsNotLite, async (): Promise<Result> => {
	const ticket = SalesStore.getTicket();

	if (!ticket.HasLoyaltyInfo)
		await Command.execute('addLoyaltyInfo');
	else
		await Command.execute('removeLoyaltyInfo');

	return Result.ok();
});